<template>
    <el-row>
        <table-template :queryParams="queryParams" actionUrl="distributor/findMemberInviteMemberTop.action"
                        ref="Table">
            <template slot="search">
                <el-row :gutter="10">
                <el-col :span="8">
                    <el-date-picker
                            @change="onDateTimeChange"
                            end-placeholder="结束日期"
                            range-separator="至"
                            start-placeholder="开始日期"
                            type="datetimerange"
                            v-model="queryParams.startEndTime">
                    </el-date-picker>
                </el-col>

                <el-col :span="2">
                    <el-button @click="$refs.Table.search()" type="primary">搜索</el-button>
                </el-col>
    </el-row>

</template>
<template slot="item">
    <el-table-column
            label="排名"
            prop="ranking">
    </el-table-column>
    <el-table-column
            label="姓名"
            prop="nickname">
    </el-table-column>
    <el-table-column
            label="手机号"
            prop="phone">
    </el-table-column>
    <el-table-column
            label="数量"
            prop="count">
    </el-table-column>

</template>
</table-template>
</el-row>
</template>

<script>
import TableTemplate from '@/components/TableTemplate'
import BasicPager from '@/mixins/BasicPager'
import DateUtil from '@/framework/utils/DateUtil'

export default {
  components: {
    TableTemplate
  },
  extends: BasicPager,
  name: 'member-ranking',
  data: function () {
    return {
      queryParams: {
        startEndTime: null
      }
    }
  },
  created: function () {
    let startTime = DateUtil.getDayStartTime()
    let endTime = DateUtil.getDayEndTime()
    this.queryParams.startEndTime = [startTime, endTime]
    this.queryParams.startTime = startTime.getTime()
    this.queryParams.endTime = endTime.getTime()
  },
  methods: {
    onDateTimeChange (dates) {
      if (dates && dates.length === 2) {
        this.queryParams.startTime = dates[0].getTime()
        this.queryParams.endTime = dates[1].getTime()
      } else {
        this.queryParams.startTime = null
        this.queryParams.endTime = null
        this.queryParams.startEndTime = []
      }
      this.$refs.Table.search()
    }
  },
  filters: {}
}
</script>

<style scoped>
</style>
